<script lang="ts" setup>
	const { query, meta } = useRoute()
	const { logout } = useAuth()
	const { isLoggedIn } = reactor(useUser())
	const { toLower } = useUtils()
	const currentRoute = computed(() => {
		const { name } = useRoute()
		return toLower(String(name))
	})
	const isLayout = computed(() => useRoute().meta.layout === 'auth')
	const routePaths = computed(() => {
		const { path } = useRoute()
		return String(path).split('/')
	})

	const routeText = computed(() => {
		return currentRoute.value === 'login'
			? "Don't have a business account? "
			: 'Trying to get care for yourself and loved oned? '
	})

	const routePath = computed(() => {
		return currentRoute.value === 'login'
			? '/register'
			: { path: `${import.meta.env.VITE_INDIVIDUAL_URL}/register`, query }
	})

	const routeActionText = computed(() => {
		return currentRoute.value === 'login' ? 'Register' : 'Get covered as an individual'
	})
</script>

<template>
	<nav class="sticky top-0 z-[1000] min-h-[80px] w-full border-b bg-gray-50 px-3 py-5">
		<div class="mx-auto flex w-full cursor-pointer flex-wrap items-center justify-between gap-y-2 md:w-11/12">
			<div class="mr-4 flex items-end gap-x-4">
				<nuxt-link to="/">
					<img
						src="~/assets/svg/logos/mcg-logo.svg"
						alt="logo"
						loading="lazy"
						height="36.67px"
						width="137.5px"
						crossorigin="use-credentials"
						class="w-auto"
					/>
				</nuxt-link>
				<div
					v-if="isLayout"
					class="inline-flex translate-y-2 rounded-3xl bg-primary-50 px-5 py-1.5 font-medium text-primary-2"
				>
					Business
				</div>
			</div>

			<div v-if="isLayout && !isLoggedIn" class="p-2 text-sm sm:ml-auto md:p-0 lg:p-0 lg:text-base">
				<span class="text-blueGray-600">{{ routeText }}</span>
				<nuxt-link
					:to="routePath"
					class="font-medium text-primary-2"
					:target="currentRoute !== 'login' ? '_blank' : ''"
					:external="currentRoute !== 'login'"
				>
					{{ routeActionText }}
				</nuxt-link>
			</div>
			<button
				v-else-if="routePaths.includes('verify-account') || (isLoggedIn && meta.layout === 'auth')"
				type="button"
				aria-roledescription="log out button"
				class="font-medium text-primary-2 hover:text-primary-300"
				@click="logout"
			>
				Log out
			</button>
		</div>
	</nav>
</template>
